import React from "react";
import { useNavigate } from "react-router-dom";
import "./404.css";

function NotFound() {
    const navigate = useNavigate();
    function returnHome() {
        return navigate("/");
    }
    return (
        <div className="notfound-container">
            <div className="notfound-content">
                <span>404 </span>

                <span>page not found</span>

                <button className="notfound-button" onClick={returnHome}>
                    Go back to Home
                </button>
            </div>
        </div>
    );
}

export { NotFound };
